
import { createContext } from 'react';
import { localStorageService } from '../services/localStorageService';

const lang =  localStorageService.get('lang') ?? import.meta.env.VITE_DEFAULT_LANG;

export const LangContext=createContext({
    lang:lang,
    setLang:(e:any)=>{
        localStorageService.set('lang', e);
    }
})

